import React from 'react'
import Item, { ItemLevel1, ItemLevel2 } from '../types/Item'
import Level3LayoutProps from '../types/Level3LayoutProps'
import parse from 'html-react-parser'

const libraryImages = {
  'map': require("~images/map.svg") as string,
}

const IS_GOOGLE_TRANSLATE = !!window.location.host.match('bpl-bc-ca.translate.goog')

export default ({ level2active }: Level3LayoutProps) => {
  return (
    <div className="level-3" id={level2active.slug}>
      <div key={level2active.id} className="details locations-hours">
        <div className="map">
          <img src={libraryImages.map} />
        </div>
       
        {level2active.menusLocations.map((location, index) => {
          const locationUrl = IS_GOOGLE_TRANSLATE ? window.location.origin + "/shortcuts/locations-hours/" + location.link.slug + window.location.search : "/shortcuts/locations-hours/" + location.link.slug
          return (
            <div className="location" key={index}>
            <a href={locationUrl}>
              <img src={location.image.url} alt={location.image.title} />
              <h1>{index + 1 + '. ' + location.link.title } </h1>
            </a>
            <p>{location.address}<br/>
               <a href={location.phoneNumber}>{location.phoneNumber.slice(4) }</a></p>
            <p>
              <a href={locationUrl} className="more-info">Branch Info</a>
              <a href={location.mapLink} target="_blank">Map</a>
            </p>
            {
              location.optionalLink !== null &&
              <>
                <p style={{ fontWeight: "bold", marginBottom: 0 }}>{location.optionalHeader}</p>
                <a href={location.optionalLink}>Learn More &rarr;</a>
              </>
            }

            <h2 style={{ marginTop: '1rem' }}>Hours</h2>
            <dl className="hours">
              <dt>Mon</dt>
              <dd className="time">{location.mondayHours}</dd>
              <dt>Tue</dt>
              <dd className="time">{location.tuesdayHours}</dd>
              <dt>Wed</dt>
              <dd className="time">{location.wednesdayHours}</dd>
              <dt>Thu</dt>
              <dd className="time">{location.thursdayHours}</dd>
              <dt>Fri</dt>
              <dd className="time">{location.fridayHours}</dd>
              <dt>Sat</dt>
              <dd className="time">{location.saturdayHours}</dd>
              <dt>Sun</dt>
              <dd className="time">{location.sundayHours}</dd>
            </dl>
          </div>
          )
        })}

      </div>
    </div>
  )
}